import store from "../../store/store"
import { UsersHubV2 } from "../hubs/usersV2"

export const usersHubV2 = new UsersHubV2(store)
